export default __webpack_public_path__ + "static/media/poppins-bold.666253c2.woff2";